module.exports = __webpack_public_path__ + "media/images/red_light-931d0b6051801dc8b3287cd02008b5f6.jpg";